module.exports = __webpack_public_path__ + "img/step-04-android.aca0e027.svg";